import { merge } from '../../../util/index';
import { Http, Id, Resource, TxLock } from '../../models/index';
import { UseCase } from '../UseCase';
import { GetLink } from './GetLink';
import { RequestResource } from './RequestResource';

export namespace SaveResource {
    export interface Params<T extends Resource<string>> {
        resource: T;
        updates?: Partial<T>;
    }
}

export class SaveResource<T extends Resource<string> & Id & TxLock>
    implements UseCase<SaveResource.Params<T>, Promise<T | undefined>>
{
    private getLink = new GetLink<string>();
    private requestResource: RequestResource<string, Partial<T>, T>;

    constructor(http: Http) {
        this.requestResource = new RequestResource<string, Partial<T>, T>(http);
    }

    execute({ resource, updates }: SaveResource.Params<T>): Promise<T | undefined> {
        const patch = this.getLink.execute({ parent: resource, rel: 'patch' });
        const put = this.getLink.execute({ parent: resource, rel: 'put' });
        if (patch || put) {
            let body = updates || resource;
            if (patch) {
                body.id = resource.id;
                body.txLock = resource.txLock;
            } else {
                body = merge.recursive({}, resource, updates);
            }

            return this.requestResource.execute({
                body,
                method: patch ? 'PATCH' : 'PUT',
                parent: resource,
                rel: patch ? 'patch' : 'put'
            });
        } else {
            return Promise.reject(new Error('The resource cannot be saved'));
        }
    }
}
